import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import MyStorages from './MyStorages';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, items, error, message,
  } = state.box;
  return {
    isLoading,
    items,
    error,
    message,
  };
}

const Styled = withStyles(styles)(MyStorages);

export default connect(
  mapStateToProps,
)(Styled);
